var render = function render(){var _vm=this,_c=_vm._self._c;return _c('el-popover',{attrs:{"placement":"top-start","title":"","width":"200","trigger":"hover","content":_vm.content}},[_c('img',{attrs:{"slot":"reference","src":_vm.icoCircleInfo,"alt":"info","width":_vm.width},slot:"reference"})])
}
var staticRenderFns = []

export { render, staticRenderFns }